import React from 'react';
import CircularCarouselSymptoms from '../CircularCarousel/CircularCarouselSymptoms';
import Link from '../../../shared/Link/Link';
import { SymptomIcon } from '../CircularCarousel/SymptomsIcons';
import { css } from '@emotion/core';

import './ModuleBrandsCarousel.scss';

const ModuleSymptomsCarousel = ({
  primaryColor,
  secondaryColor,
  symptomsData,
  circularCarouselSymptomsVersion,
  coloredBackgroundCircularCarouselSymptoms,
  sliderCircleArrowsSymptoms,
  symptomsCarouselTitle,
  isMobile,
}) => {
  const circularCarouselSymptomsStyle = css`
    &.colored-bg {
      background-color: #f8f8f8;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      @media screen and (max-width: 650px) {
        padding: 16px !important;
      }
      @media screen and (min-width: 651px) {
        padding: ${circularCarouselSymptomsVersion !== 3
          ? '28px 40px 28px 40px !important'
          : '28px 50px 28px 50px !important'};
      }
      .title-container h2 {
        font-size: 22px;
        font-weight: 600;
      }
      & .slick-slider {
        & .slick-arrow.slick-prev {
          left: ${circularCarouselSymptomsVersion === 1 ? '-1%' : '-2%'};
        }
        & .slick-arrow.slick-next {
          right: ${circularCarouselSymptomsVersion === 1 ? '0%' : '-0.5%'};
        }
      }
    }
  `;

  const renderCarouselSymptoms = () => {
    if (isMobile) {
      return renderCarouselSymptomsMobile();
    } else {
      return renderCarouselSymptomsDesktop();
    }
  };

  const renderCarouselSymptomsDesktop = () => {
    return (
      <div className="hidden-mobile">
        <CircularCarouselSymptoms
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          symptomsData={symptomsData}
          coloredBackgroundCircularCarouselSymptoms={
            coloredBackgroundCircularCarouselSymptoms
          }
          sliderCircleArrowsSymptoms={sliderCircleArrowsSymptoms}
          circularCarouselSymptomsVersion={circularCarouselSymptomsVersion}
          symptomsCarouselTitle={symptomsCarouselTitle}
          circularCarouselSymptomsStyle={circularCarouselSymptomsStyle}
        />
      </div>
    );
  };

  const renderCarouselSymptomsMobile = () => {
    return (
      <div className="hidden-desktop">
        <div className="circular-carousel-symptoms">
          <div
            className={`${
              coloredBackgroundCircularCarouselSymptoms === 1
                ? 'colored-bg'
                : coloredBackgroundCircularCarouselSymptoms === 2
                ? 'container'
                : ''
            }`}
            css={circularCarouselSymptomsStyle}
          >
            <div style={{ margin: '0 0 1rem 0' }}>
              <h2 style={{ fontSize: 20, fontWeight: 500, marginBottom: 0 }}>
                {symptomsCarouselTitle}
              </h2>
            </div>
            <div className="circular-carousel-container">
              {!!symptomsData &&
                symptomsData
                  .filter(item => !!item.publishFarmakom)
                  .map(item => (
                    <div className="symptom-container">
                      <div
                        style={{
                          backgroundColor: '#fff',
                          borderRadius: '50%',
                          border: '1px solid #eaeaea',
                          width: 100,
                          height: 100,
                        }}
                      >
                        <Link
                          aria-label={`Guarda i prodotto per il sintomo ${item.name}`}
                          to={'/sintomo/' + item.name}
                        >
                          <SymptomIcon
                            type={item.name}
                            primaryColor={primaryColor}
                            secondaryColor={secondaryColor}
                            fallbackImage={item.imageUrl}
                            width={100}
                          />
                        </Link>
                      </div>
                      <Link
                        aria-label={`Guarda i prodotto per il sintomo ${item.name}`}
                        to={'/sintomo/' + item.name}
                      >
                        <h3
                          className="symptom-subtitle"
                          style={{
                            textAlign: 'center',
                            fontSize: 14,
                            marginTop: 8,
                            color: 'black',
                          }}
                        >
                          {item.name}
                        </h3>
                      </Link>
                    </div>
                  ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return <>{renderCarouselSymptoms()}</>;
};
export default ModuleSymptomsCarousel;
